import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

function* loadRequestMaterial(action) {
  const {
    data: {
      location_visibility,
      page,
      pageSize,
      orderBy,
      orderType,
      accessToken,
      is_admin,
      is_vendor,
      company_id,
      filterObj,
      type,
      limit_export,
      file_value_pdf,
      exactly_location,
      mill_location_list,
      plant_location_list,
      material_visibility,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get/new/requestmaterial`,
      {
        location_visibility,
        page,
        pageSize,
        orderBy,
        orderType,
        is_admin,
        is_vendor,
        company_id,
        filterObj,
        type,
        limit_export,
        file_value_pdf,
        exactly_location,
        mill_location_list,
        plant_location_list,
        material_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    yield put(actions.loadRequestMaterial.success(res.data, page, pageSize))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadRequestMaterial.failure())
  }
}

function* exportRequestMaterial(action) {
  const {
    data: {
      location_visibility,
      page,
      pageSize,
      orderBy,
      orderType,
      accessToken,
      is_admin,
      is_vendor,
      company_id,
      filterObj,
      type,
      limit_export,
      file_value_pdf,
      exactly_location,
      mill_location_list,
      plant_location_list,
      material_visibility,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get/new/requestmaterial`,
      {
        location_visibility,
        page,
        pageSize,
        orderBy,
        orderType,
        accessToken,
        is_admin,
        is_vendor,
        company_id,
        filterObj,
        type,
        limit_export,
        file_value_pdf,
        exactly_location,
        mill_location_list,
        plant_location_list,
        material_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    yield put(actions.exportRequestMaterial.success(res.data, page))
    const sftpPath = res.data.data
    const downloadRes = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
      { sftp_path: sftpPath },
      { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
    )
    const ext = sftpPath.split('.').pop().toLowerCase()
    const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const blob = new Blob([downloadRes.data], { type: mimeType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = sftpPath.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (err) {
    console.log(err.message)
    yield put(actions.exportRequestMaterial.failure())
  }
}

function* createRequestMaterial(action) {
  const {
    data: { files, request_date, checked, running_dn_number, accessToken },
    loading,
  } = action.payload

  const formData = new FormData()
  let uploadFile = null

  if (files != null) {
    files.forEach((File) => {
      uploadFile = File
    })
  }

  formData.append('files', uploadFile)
  formData.append('request_date', request_date)
  formData.append('checked', checked)
  formData.append('running_dn_number', running_dn_number)

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/new-createrequestmaterial`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    loading(res.data)
    yield put(actions.createRequestMaterial.success(res.data))
  } catch (err) {
    console.log(err)
    yield put(actions.createRequestMaterial.failure())
  }
}

// *load division
function* requestMaterialLoadDivision(action) {
  const {
    data: {
      material_visibility,
      location_visibility,
      division_id,
      department_id,
      section_id,
      plant_id,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/request-material/get-division`,
      {
        material_visibility,
        location_visibility,
        division_id,
        department_id,
        section_id,
        plant_id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.requestMaterialLoadDivision.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.requestMaterialLoadDivision.failure())
  }
}

// *load department
function* requestMaterialLoadDepartment(action) {
  const {
    data: {
      material_visibility,
      location_visibility,
      division_id,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/request-material/get-department`,
      {
        material_visibility,
        location_visibility,
        division_id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.requestMaterialLoadDepartment.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.requestMaterialLoadDepartment.failure())
  }
}

// *load section
function* requestMaterialLoadSection(action) {
  const {
    data: {
      material_visibility,
      location_visibility,
      division_id,
      department_id,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/request-material/get-section`,
      {
        material_visibility,
        location_visibility,
        division_id,
        department_id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.requestMaterialLoadSection.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.requestMaterialLoadSection.failure())
  }
}

// *load plant
function* requestMaterialLoadPlant(action) {
  const {
    data: {
      material_visibility,
      location_visibility,
      division_id,
      department_id,
      section_id,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/request-material/get-plant`,
      {
        material_visibility,
        location_visibility,
        division_id,
        department_id,
        section_id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.requestMaterialLoadPlant.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.requestMaterialLoadPlant.failure())
  }
}

// *load material
function* requestMaterialLoadMaterial(action) {
  const {
    data: { material_visibility, plant_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/request-material/get-material`,
      { material_visibility, plant_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.requestMaterialLoadMaterial.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.requestMaterialLoadMaterial.failure())
  }
}

// *load preview request material multiple plant
function* requestMaterialPreviewRequestMultiplePlant(action) {
  const {
    data: {
      delivery_date,
      division_id,
      department_id,
      section_id,
      plant_id,
      material_id,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/request-material/generate-request-material-multiple-plant`,
      {
        delivery_date,
        division_id,
        department_id,
        section_id,
        plant_id,
        material_id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(
      actions.requestMaterialPreviewRequestMultiplePlant.success(res.data)
    )
  } catch (err) {
    console.log(err.message)
    yield put(actions.requestMaterialPreviewRequestMultiplePlant.failure())
  }
}

// *load preview ticket multiple plant
function* requestMaterialPreviewTicketMultiplePlant(action) {
  const {
    data: { data, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/request-material/generate-ticket`,
      {
        data,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(
      actions.requestMaterialPreviewTicketMultiplePlant.success(res.data)
    )
  } catch (err) {
    console.log(err.message)
    yield put(actions.requestMaterialPreviewTicketMultiplePlant.failure())
  }
}

// *create ticket multiple plant
function* requestMaterialCreateTicketMultiplePlant(action) {
  const {
    data: { data, record_for_create, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/request-material/create-ticket-multiple-plant`,
      {
        data,
        record_for_create,
        matching_name: 'isupply-request-material-multiple-plant',
        action_name: 'add',
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(
      actions.requestMaterialCreateTicketMultiplePlant.success(res.data)
    )
  } catch (err) {
    console.log(err.message)
    yield put(actions.requestMaterialCreateTicketMultiplePlant.failure())
  }
}

// *today action multiple plant
function* requestMaterialTodayActionMultiplePlant(action) {
  const {
    data: {
      material_id,
      dest_locations_id,
      start_delivery_date,
      end_delivery_date,
      type,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/request-material/today-action-multiple-plant`,
      {
        material_id,
        dest_locations_id,
        start_delivery_date,
        end_delivery_date,
        type,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.requestMaterialTodayActionMultiplePlant.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.requestMaterialTodayActionMultiplePlant.failure())
  }
}

// *preview plant request multiple plant
function* requestMaterialPreviewPlantRequestMultiplePlant(action) {
  const {
    data: {
      division_id,
      department_id,
      section_id,
      plant_id,
      delivery_date,
      material_id,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/request-material/generate-plant-request-multiple-plant`,
      {
        division_id,
        department_id,
        section_id,
        plant_id,
        delivery_date,
        material_id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(
      actions.requestMaterialPreviewPlantRequestMultiplePlant.success(res.data)
    )
  } catch (err) {
    console.log(err.message)
    yield put(actions.requestMaterialPreviewPlantRequestMultiplePlant.failure())
  }
}

// *request realtime stock multiple plant
function* requestRealtimeStockMultiplePlant(action) {
  const {
    data: {
      division_id,
      department_id,
      section_id,
      plant_id,
      delivery_date,
      material_id,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/request-material/realtime-stock`,
      {
        division_id,
        department_id,
        section_id,
        plant_id,
        delivery_date,
        material_id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.requestRealtimeStockMultiplePlant.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.requestRealtimeStockMultiplePlant.failure())
  }
}

export default function* watchRequestMaterial() {
  yield all([
    takeEvery(actions.CREATE_REQUEST_MATERIAL.REQUEST, createRequestMaterial),
    takeEvery(actions.LOAD_REQUEST_MATEL.REQUEST, loadRequestMaterial),
    takeEvery(actions.EXPORT_REQUEST_MATEL.REQUEST, exportRequestMaterial),
    takeEvery(
      actions.REQUEST_MATERIAL_LOAD_DIVISION.REQUEST,
      requestMaterialLoadDivision
    ),
    takeEvery(
      actions.REQUEST_MATERIAL_LOAD_DEPARTMENT.REQUEST,
      requestMaterialLoadDepartment
    ),
    takeEvery(
      actions.REQUEST_MATERIAL_LOAD_SECTION.REQUEST,
      requestMaterialLoadSection
    ),
    takeEvery(
      actions.REQUEST_MATERIAL_LOAD_PLANT.REQUEST,
      requestMaterialLoadPlant
    ),
    takeEvery(
      actions.REQUEST_MATERIAL_LOAD_MATERIAL.REQUEST,
      requestMaterialLoadMaterial
    ),
    takeEvery(
      actions.REQUEST_MATERIAL_PREVIEW_REQUEST_MULTIPLE_PLANT.REQUEST,
      requestMaterialPreviewRequestMultiplePlant
    ),
    takeEvery(
      actions.REQUEST_MATERIAL_PREVIEW_TICKET_MULTIPLE_PLANT.REQUEST,
      requestMaterialPreviewTicketMultiplePlant
    ),
    takeEvery(
      actions.REQUEST_MATERIAL_CREATE_TICKET_MULTIPLE_PLANT.REQUEST,
      requestMaterialCreateTicketMultiplePlant
    ),
    takeEvery(
      actions.REQUEST_MATERIAL_TODAY_ACTION_MULTIPLE_PLANT.REQUEST,
      requestMaterialTodayActionMultiplePlant
    ),
    takeEvery(
      actions.REQUEST_MATERIAL_PREVIEW_PLANT_REQUEST_MULTIPLE_PLANT.REQUEST,
      requestMaterialPreviewPlantRequestMultiplePlant
    ),
    takeEvery(
      actions.REQUEST_REALTIME_STOCK_MULTIPLE_PLANT.REQUEST,
      requestRealtimeStockMultiplePlant
    ),
  ])
}

export {
  loadRequestMaterial,
  createRequestMaterial,
  exportRequestMaterial,
  requestMaterialLoadDivision,
  requestMaterialLoadDepartment,
  requestMaterialLoadSection,
  requestMaterialLoadPlant,
  requestMaterialLoadMaterial,
  requestMaterialPreviewRequestMultiplePlant,
  requestMaterialPreviewTicketMultiplePlant,
  requestMaterialCreateTicketMultiplePlant,
  requestMaterialTodayActionMultiplePlant,
  requestMaterialPreviewPlantRequestMultiplePlant,
  requestRealtimeStockMultiplePlant,
}
